import { memo, useCallback } from 'react';

import { IconButton } from '../../../button';

// Memoized individual emoji button to prevent unnecessary re-renders
export const EmojiButton = memo(function EmojiButton({
  emoji,
  label,
  onSelect,
}: {
  emoji: string;
  label?: string;
  onSelect: (emoji: string) => void;
}) {
  const handleClick = useCallback(() => {
    onSelect(emoji);
  }, [emoji, onSelect]);

  return (
    <IconButton
      key={emoji}
      aria-label={label}
      title={label}
      size={24}
      style={{ padding: 4 }}
      icon={<span>{emoji}</span>}
      iconStyle={{ justifyContent: 'center' }}
      onClick={handleClick}
    />
  );
});
